import actions from "./actions";

const initialState = {
  loading: false,
  list: {},
  error: false,
};

export default function historyReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_STATE:
      return { ...state, ...action.payload };
    default:
      return state;
  }
}
